const INFO = {
	main: {
		title: "Varun Singh",
		name: "Varun Singh",
		email: "vksingh8@asu.edu",
		logo: "../images/logo.png",
	},

	socials: {
		github: "https://github.com/Dephinate",
		linkedin: "https://www.linkedin.com/in/vks2102/",	},
 
	homepage: {
		name: "Varun Kumar Singh",
		title: "AI Engineer",
		description:
			"Hello!, I am Varun, an AI Engineer at Radical AI, where I specialize in developing cutting-edge generative AI applications to create innovative solutions across various domains, including healthcare, education, and customer support. By leveraging the latest tools in AI, such as RAG, Langchain, Vector DBs, OpenAI, VertexAI, GPT, Gemini, and HuggingFace, I am at the forefront of pushing the boundaries of what is possible. My journey in technology has always been driven by a desire to solve real-world problems, and now, I’m excited to be focusing on developing AI Teaching Assistants that can adapt to individual learning styles, provide immediate feedback, and support educators in ways we’ve only dreamed of before. Prior to my current role, I was an Azure Developer at Tata Consultancy Services where I developed smart B2B workflow automation applications using Azure Integration Services, Machine Learning Pipelines, and AzureAI. Beyond this, my background encompasses a deep passion for Natural Language Processing and a keen interest in advancing the perception capabilities of Autonomous Vehicles using Deep Learning. I am a lifelong learner, continually exploring the ever-evolving landscape of AI to stay at the forefront of technological advancements. I am excited about the future of AI and how it can be leveraged to create meaningful change and solve some of the world's most pressing challenges."
			// "Hello, I am Varun, an AI Engineer, currently working at Radical. I work on developing and integrating Generative AI applications into Education, Healthcare, and Customer Service and Support. I am utilizing OpenAI, Google Gemini, VertexAI, Langchain,  React, FastAPI, and vector databases/libraries such as Pinecone, Chroma DB, and FAISS for developing KAI, an AI-powered Teaching Assistant for educators. My current task is adding features to personalize learning experiences, enhance student engagement, and streamline administrative tasks for teachers, ultimately making the educational experience more adaptive and responsive to individual student needs."
	},

	about: {
		title: "My Story",
		// description:"My journey into the world of artificial intelligence began as a graduate student researcher at ASU's Interactive Robotics Lab, I delved in human-robot collaboration and crafted a real-time 3D object tracking system using advanced computer vision and Intel's RGB depth camera. \n Transitioning to a machine learning research assistant role at ASU's Geometric Media Lab, I deepened my knowledge in generative models like GANs and VAEs, creating novel interpolation techniques and a CNN architecture that attracted DARPA funding. My 3D computer vision pursuits led me to an internship at Meda AI in New York, where I enhanced the Neural Radiance Field (NERF) algorithm for improved 3D reconstructions. \n Now at Sabin Lighting Inc. in Chicago as a machine learning engineer, I apply ML in industry automation, developing AI chatbots using OpenAI's retrieval-augmented generation, and devise ML-driven pricing algorithms.",
		description: "My introduction to Artificial Intelligence began during my undergraduate capstone project, where I developed a Hand Gesture Recognition system. Creating a dataset, building a neural network, and tuning hyperparameters revealed AI's immense potential, but also how much I had to learn. This humbling experience sparked a lifelong passion for exploring AI's full capabilities.\n Being an engineer, I envisioned how AI could seamlessly integrate into our lives, enhancing capabilities and solving complex challenges across industries like healthcare, sustainability, transportation, and education. Driven to be at the forefront of this transformative revolution, I decided to pursue a Master's in Robotics and AI. But first, I took a strategic detour into the corporate world at TCS as an Azure Integration Developer, honing skills in workflow automation, cloud migration, and machine learning pipelines.\n After a year and a half, equipped with newfound confidence and resources, I embarked on my next adventure: a Master's in Robotics at Arizona State University. Here, I built a solid foundation through rigorous coursework, progressing to complex subjects like Machine Learning, Deep Learning, and Large-Scale Data Processing. My passion was further ignited through diverse projects and research, like advancing perception capabilities of autonomous vehicles through AI as a Student Researcher.\n Alongside research, I guided students as a Teaching Assistant and inspired the next generation as a High School Mathematics Tutor. These experiences were about imparting knowledge while learning in return.\n While versatility is valuable, I've chosen AI as my weapon. My winding path, filled with diverse experiences, has fueled my passion for learning and innovation. As I continue this journey, I'm excited to contribute to a future where AI transforms how we live, learn, and interact with the world.",
		resume: "https://drive.google.com/file/d/1IhEiaTxqApjYZTpHRoFZHLYobrFLb2y-/view",
	},

	projects: {
		title: "Exploring Artificial Intelligence: A Journey Through Projects",
		description:
			`Throughout my journey exploring Artificial Intelligence, I've immersed myself in a variety of projects, each contributing to the depth of my understanding and skill set. This section offers a glimpse into some of these milestones, showcasing the range and complexity of challenges I've tackled.`,
		description2: " If any of these projects align with your interests, I'd be delighted to discuss potential collaborations. Additionally, if you have a project in mind, I'm open to exploring how we might bring it to fruition together. Let's leverage the power of AI to innovate and create meaningful solutions.",
			project_list: [
			{
				title: "Mister RetrieveRite",
				description:
					"RAG (Retrieval Augmented Generation) based Chatbot, designed for effective, efficient, and high-quality search and text generation.",
				image: "https://github.com/Dephinate/MisterRetriveRite/blob/main/data/preview.gif?raw=true",
				image_alt: "webchat-demo",
				skills: [
					"rag",
					"Langchain", 
					"Openai", 
					"pinecone", 
					"gpt_35_turbo",
					"HuggingFace",
					"streamlit",
					"python"
				],
				linkText: "View Project",
				link: "https://github.com/Dephinate/MisterRetriveRite/tree/main",
			},
			{
				title: "QuizMaster",
				description:
					"QuizMaster is an innovative GenAI-powered tool designed to generate quizzes from any educational document with ease",
				image: "https://github.com/Dephinate/QuizMaster/blob/main/data/demo.gif?raw=true",
				image_alt: "webchat-demo",
				skills: [
					"rag",
					"Langchain",
					"vertexai",
					"chromadb",
					"gemini",
					"streamlit",
					"python"
					
					
				],
				linkText: "View Project",
				link: "https://github.com/Dephinate/QuizMaster.git",
			},
			{
				title: "YouTube FlashCard Generator",
				description:
					"YouTubeFlashCard is an AI tool that generates flashcards by extracting key concepts, terms, and definitions from YouTube videos using gemini 1.5 pro at 95% lower cost and 90% lower processing time.",
				image: "https://github.com/Dephinate/GeminiDynamo/blob/main/data/dynamo.gif?raw=true",
				image_alt: "sim-demo",
				skills: ["python","react", "gemini", "Langchain"],
				linkText: "View Project",
				link: "https://github.com/Dephinate/GeminiDynamo.git",
			},
			{
				title: "Intelligent Parking Sapce Detection",
				description:
					"Parking space detection system for identifying, localizing, and navigating to free parking spaces in a parking lot built by inegrating multiple cameras and fine-tuning YOLO, achieving 97% accuracy against ocllusions and perspective distortions. Deployed on NVIDIA Jetson AGX Orion for handling similtanious video streams from cameras, enabling low-latency",
				image: "https://github.com/Dephinate/QuizMaster/blob/main/data/parkingspace.gif?raw=true",
				image_alt: "drone flight simulation",
				skills: [
					"pytorch",
					"opencv",
					"YOLO",
					"cuda",
					"linux",
					"agx_orion"
				],
				linkText: "View Project",
				link: "https://youtu.be/PPt7d1hTMuw?si=tayvCDJUYJmSTLlS",
			},
			{
				title: "Dialogue Summarizer",
				description:
					"Dialogue summarizer built by fine-tuning PEGASUS model on samsum dataset. Consists an end-to-end pipeline for data ingestion, data transformation, data evaluation, model training, and model evaluation.",
				image: "https://github.com/Dephinate/TextSummarization/blob/main/data/display.png?raw=true",
				image_alt: "Dialogue Summarizer",
				skills: ["rag","github_ci_cd","github_actions","pegasus", "aws_ec2", "docker"],
				linkText: "View Project",
				link: "https://github.com/Dephinate/TextSummarization.git",
			},

			{
				title: "On-road LiDAR Vulnerable Road User (VRU) Classification using Deep Learning",
				description:
					"An investigation into the performance of deep learning models like PointNet, PointNet++, and DGCNN for classifying on-road entities such as Vehicles, Pedestrians, and Cyclists on real-world datasets.",
				image: "https://github.com/Dephinate/TextSummarization/blob/main/data/Waymo.gif?raw=true",
				image_alt: "PointCloud",
				skills: ["pytorch", "numpy","python"],
				linkText: "View Project",
				link: "https://drive.google.com/file/d/1IIE5z72YzvuZKbvEQUFTUIV3dN990608/view?usp=sharing",
			}
		],
	},

	research: { 
		title: "My Research Experience",
		description:
			"During my master's at ASU, I had the privilege to work on advancing the perception capabilities of Autonomous Vehicles and Intelligent Parking Systems using Artificial Intelligence at the Battery Electric & Intelligent Vehicle (BELIV) Lab under the guidance of Dr. Junfeng Zhao. Below are the highlights of the work I did at the lab.",
	
		},

	experience: [
		{
			company_logo:
				"https://media.licdn.com/dms/image/D4D0BAQFM2yEFiYZfew/company-logo_200_200/0/1710708108304/radicalai_li_logo?e=1724889600&v=beta&t=QY0mFspr-5mfGKErKmEISks99d0g5_2SLJ4TCiMoKeY",
			company: "RadicalAI",
			location:"New York, New York",
			roles: [
				{
					dept:"Artificial Intelligence",
					role: "AI Engineer - Intern",
					duration: "June 2024  - Present",
					description:
						" Contributing to an open-source project, Kai, an AI-powered Teaching Assistant for educators, to personalize learning experiences, enhance student engagement, and streamline administrative tasks for teachers.\n Utilizing RAG, Langchain, VertexAI, OpenAI, GPT, Gemini, Vector Databases, Streamlit, and React to develop and deploy features.\n Designing prompts to refine the model's response for clarity and relevancy.",
				},
			],
		},
		
		{
			company_logo:
				"https://upload.wikimedia.org/wikipedia/commons/b/b1/Tata_Consultancy_Services_Logo.svg",
			company: "Tata Consultancy Services",
			location:"New Delhi",
			roles: [
				{
					dept:"Enterprise Integration",
					role: "Cloud Engineer",
					duration: "April 2021 - August 2022",
					description:
						"Developed and designed workflow automation and enterprise integration applications using Azure Integration Services.\n Remodeled and migrated the on-premise BizTalk application to the cloud.\n Developed automation scripts using Powershell to automate the independent testing of dependent applications in the workflow, reducing the development and deployment time by 30%. ",
				},
			],
		},
		{
			company_logo:
				"https://media.licdn.com/dms/image/C560BAQHDGjY1IZJuog/company-logo_200_200/0/1631309406468?e=1723680000&v=beta&t=9kv_PzaPf3Ts3D-Nb_JudCiFyrGsNANIsHXrQ9V2lnY",
			company: "Battery Electric & Intelligent Vehicle Lab",
			location:"Tempe, AZ",
			roles: [
				{
					dept:"Robotics and Artificial Intelligence",
					role: "Student Researcher",
					duration: "August 2023 - Present",
					description:
						"Developed and designed an parking space detection sytem for Autonomous Vehicles in collaboration with Cox and ASU.\n Incorporated multiple cameras in the parking lot and fine tuned YOLO for generalizing parking space extraction and classification while reducing perspective distortions and achieving an accuracy of 95% against occlusions.",
				},
			],
		},
		{
			company_logo:
				"https://media.licdn.com/dms/image/C560BAQHDGjY1IZJuog/company-logo_200_200/0/1631309406468?e=1723680000&v=beta&t=9kv_PzaPf3Ts3D-Nb_JudCiFyrGsNANIsHXrQ9V2lnY",
			company: "Arizona State University",
			location:"Tempe, AZ",
			roles: [
				{
					dept: "Electrical Engineering",
					role: "Teaching Assistant",
					duration: "July 2022 - May 2023",
					description:
						"Helped students determine their capstone project goals related to Deep Learning, IoT, Computer Vision, and Natural Language Processing.\n Guided students through the process of selecting appropriate datasets and models, training models, and optimizing algorithms to achieve project objectives."
				},
			],
		}


	],
};

export default INFO;
